import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BRAND } from '../../config/branding';

export default function SplashPage() {
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);
  const done = useRef(false);

  const exit = () => {
    if (done.current) return;
    done.current = true;
    setExiting(true);
    setTimeout(() => navigate('/login', { replace: true }), 650);
  };

  useEffect(() => {
    const t1 = setTimeout(() => setExiting(true), 3800);
    const t2 = setTimeout(() => {
      if (!done.current) {
        done.current = true;
        navigate('/login', { replace: true });
      }
    }, 4450);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [navigate]);

  return (
    <div
      onClick={exit}
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0D1F1F',
        opacity: exiting ? 0 : 1,
        transform: exiting ? 'scale(1.04)' : 'scale(1)',
        transition: 'opacity 0.6s ease, transform 0.6s ease',
        pointerEvents: exiting ? 'none' : 'auto',
        cursor: 'default',
        userSelect: 'none',
        overflow: 'hidden',
      }}
    >
      <style>{`
        @keyframes cli-bg-glow {
          0%,100% { opacity:0.5; transform:translate(-50%,-55%) scale(1); }
          50%      { opacity:1;   transform:translate(-50%,-55%) scale(1.12); }
        }
        @keyframes cli-icon-in {
          from { opacity:0; transform:scale(0.78) translateY(12px); }
          to   { opacity:1; transform:scale(1) translateY(0); }
        }
        @keyframes cli-breath {
          0%,100% { transform:scale(1); }
          50%      { transform:scale(1.05); }
        }
        @keyframes cli-halo {
          0%,100% { opacity:0.3; transform:scale(0.85); }
          50%      { opacity:0.7; transform:scale(1.15); }
        }
        @keyframes cli-ring-spin {
          from { transform:rotate(0deg); }
          to   { transform:rotate(360deg); }
        }
        @keyframes cli-fade-up {
          from { opacity:0; transform:translateY(10px); }
          to   { opacity:1; transform:translateY(0); }
        }
        @keyframes cli-fade {
          to { opacity:1; }
        }
        @keyframes cli-bar {
          to { width:100%; }
        }
      `}</style>

      {/* Background ambient glow */}
      <div style={{
        position: 'absolute',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(31,92,92,0.38) 0%, transparent 70%)',
        top: '50%',
        left: '50%',
        animation: 'cli-bg-glow 4s ease-in-out infinite',
        pointerEvents: 'none',
      }} />

      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '28px' }}>

        {/* Icon + animation wrapper */}
        <div style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: 0,
          animation: 'cli-icon-in 0.7s ease 0.2s forwards',
        }}>
          {/* Pulsing halo */}
          <div style={{
            position: 'absolute',
            width: '180px',
            height: '180px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(3,188,166,0.35) 0%, transparent 65%)',
            filter: 'blur(18px)',
            animation: 'cli-halo 2.8s ease-in-out infinite',
          }} />
          {/* Spinning dashed ring */}
          <div style={{
            position: 'absolute',
            width: '136px',
            height: '136px',
            borderRadius: '50%',
            border: '1.5px dashed rgba(3,188,166,0.3)',
            animation: 'cli-ring-spin 10s linear infinite',
          }} />
          {/* Icon only */}
          <img
            src="/stratel-favicon-dark.png"
            alt={BRAND.name}
            style={{
              width: '96px',
              height: '96px',
              objectFit: 'contain',
              position: 'relative',
              animation: 'cli-breath 3.5s ease-in-out 0.9s infinite',
            }}
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        </div>

        {/* Tagline */}
        <div style={{
          fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
          fontSize: '1.05rem',
          fontWeight: 500,
          letterSpacing: '0.02em',
          color: '#EDF4F4',
          opacity: 0,
          animation: 'cli-fade-up 0.6s ease 1.0s forwards',
          textAlign: 'center',
        }}>
          {BRAND.tagline}
        </div>

        {/* Portal badge */}
        <div style={{
          fontFamily: "'Inter', system-ui, sans-serif",
          fontSize: '0.68rem',
          fontWeight: 500,
          letterSpacing: '0.22em',
          textTransform: 'uppercase',
          color: '#7AA8A8',
          opacity: 0,
          animation: 'cli-fade 0.5s ease 1.6s forwards',
          marginTop: '-10px',
        }}>
          Client Portal
        </div>

        {/* Progress bar */}
        <div style={{
          width: '160px',
          height: '2px',
          background: 'rgba(255,255,255,0.08)',
          borderRadius: '2px',
          overflow: 'hidden',
          opacity: 0,
          animation: 'cli-fade 0.4s ease 2.0s forwards',
          marginTop: '-8px',
        }}>
          <div style={{
            height: '100%',
            width: '0%',
            background: 'linear-gradient(90deg, #3FA8A8, #E8A838)',
            borderRadius: '2px',
            animation: 'cli-bar 1.6s ease 2.2s forwards',
          }} />
        </div>

      </div>
    </div>
  );
}
